import classNames from 'classnames';
import { CatalogListItem, CatalogListItemProps } from '../CatalogListItem';
import styles from './CatalogList.module.scss';

export interface CatalogListProps {
	className?: string;
	items: CatalogListItemProps[];
	noItemsMessage?: string;
}

export const CatalogList: React.FC<CatalogListProps> = ({ className, items, noItemsMessage }) => {
	return (
		<ul className={classNames(className, styles.CatalogList)}>
			{items?.length > 0
				? items.map((item) => {
						return <CatalogListItem key={item.id ? item.id : item.heading.replaceAll(' ', '').replaceAll(',', '')} {...item} className={styles.CatalogList_item} />;
				  })
				: noItemsMessage && (
						<li className={classNames(styles.CatalogList_item, styles.CatalogList_item___empty)}>
							<p>{noItemsMessage}</p>
						</li>
				  )}
		</ul>
	);
};
